document.addEventListener('DOMContentLoaded', function() {
    const featureProductSlider = document.querySelector('.featured-products-slider');
    if (!featureProductSlider) return;
    
    const sectionId = featureProductSlider.id.replace('featured-products-slider-', '');
    const scrollWrapper = document.getElementById('featured-products-slider-scroll-wrapper-' + sectionId);
    const container = document.getElementById('slider-container-' + sectionId);
    const viewport = document.getElementById('slider-viewport-' + sectionId);
    const track = document.getElementById('slider-track-' + sectionId);
    
    if (!scrollWrapper || !container || !viewport || !track) return;
    
    // 防止重复初始化
    if (container.dataset.initialized === 'true') {
        return;
    }
    container.dataset.initialized = 'true';
    
    const items = Array.from(track.querySelectorAll('.slider-item'));
    const sliderBox = featureProductSlider.querySelector('.featured-products-slider-box');
    const prevButton = sliderBox ? sliderBox.querySelector('.prev-button') : null;
    const nextButton = sliderBox ? sliderBox.querySelector('.next-button') : null;
    const progressBar = featureProductSlider.querySelector('.progress-bar');
    const progressContainer = featureProductSlider.querySelector('.progress-container');
    
    if (items.length === 0) return;
    
    let slideStep = parseInt(featureProductSlider.dataset.sliderNumbers) || 1;
    if (window.innerWidth <= 480 && slideStep > 3) {
        slideStep = 3;
    } else if (window.innerWidth <= 768 && slideStep > 4) {
        slideStep = 4;
    } else if (window.innerWidth < 1200 && slideStep > 6) {
        slideStep = 6;
    } else if (window.innerWidth >= 1200 && slideStep > 8) {
        slideStep = 8;
    }
    
    // 获取滚动容器：优先使用外层滚动容器，保证进度条计算一致
    function getScrollContainer() {
        return scrollWrapper || viewport;
    }
    
    // 判断是否使用外层容器滚动
    function isUsingScrollWrapper() {
        return !!scrollWrapper;
    }
    
    // 获取容器的实际可见宽度（统一使用滚动容器的clientWidth，避免宽度误差）
    function getContainerVisibleWidth() {
        const scrollContainer = getScrollContainer();
        if (isUsingScrollWrapper()) {
            return scrollWrapper ? scrollWrapper.clientWidth : (scrollContainer ? scrollContainer.clientWidth : 0);
        } else {
            return scrollContainer ? scrollContainer.clientWidth : 0;
        }
    }

    // 获取用于限制最大滚动的有效可见宽度
    function getEffectiveVisibleWidth() {
        const scrollContainer = getScrollContainer();
        if (!scrollContainer) return 0;
        
        if (window.innerWidth >= 1648) {
            // 大屏：使用实际窗口宽度，但终点对齐到1600px逻辑容器
            return scrollContainer.clientWidth;
        } else if (window.innerWidth > 768) {
            // 中屏：使用容器实际可见宽度（已扣掉gutter）
            return scrollContainer.clientWidth;
        } else {
            // 移动端：使用容器实际可见宽度（已扣掉左侧16px padding）
            return scrollContainer.clientWidth;
        }
    }

    // 计算有效的最大滚动距离
    function getMaxScroll() {
        const scrollContainer = getScrollContainer();
        if (!scrollContainer) return 0;
        
        const scrollWidth = getContentScrollWidth();
        const visibleWidth = getEffectiveVisibleWidth();
        
        // 计算最大滚动距离：内容总宽度 - 可见宽度
        const maxScroll = Math.max(0, scrollWidth - visibleWidth);
        
        return maxScroll;
    }
    
    // 获取内容的实际宽度：直接使用实际滚动容器的 scrollWidth，避免与 track 宽度不一致
    function getContentScrollWidth() {
        const scrollContainer = getScrollContainer();
        return scrollContainer ? scrollContainer.scrollWidth : 0;
    }

    // 是否需要滚动
    function needsScroll() {
        const containerWidth = getContainerVisibleWidth();
        const scrollWidth = getContentScrollWidth();
        return (scrollWidth - containerWidth) > 1; // 加1px容差
    }
    
    // 计算可视区域能显示多少个item
    function calculateVisibleItemCount() {
        if (items.length === 0) return 0;
        
        const containerWidth = getContainerVisibleWidth();
        const firstItem = items[0];
        const itemRect = firstItem.getBoundingClientRect();
        const itemWidth = itemRect.width;
        const computedStyle = window.getComputedStyle(track);
        const gap = parseFloat(computedStyle.gap) || 32;
        
        // 计算能完整显示多少个item
        // 公式：(容器宽度 + gap) / (item宽度 + gap)
        const visibleCount = Math.floor((containerWidth + gap) / (itemWidth + gap));
        
        return Math.max(1, visibleCount); // 至少显示1个
    }
    
    // 更新居中状态：当item数量少于可视区域能显示的数量时，居中分布
    function updateCenteredState() {
        if (!track) return;
        
        const visibleCount = calculateVisibleItemCount();
        const itemCount = items.length;
        
        // 如果item数量少于或等于可视区域能显示的数量，且不需要滚动，则居中
        if (itemCount > 0 && itemCount <= visibleCount && !needsScroll()) {
            track.classList.add('is-centered');
        } else {
            track.classList.remove('is-centered');
        }
    }
    
    
    // 更新UI状态
    function updateUI() {
        const scrollContainer = getScrollContainer();
        if (!scrollContainer) return;
        
        const maxScroll = getMaxScroll();
        let scrollLeft = scrollContainer.scrollLeft;
        
        // 强制限制 scrollLeft 在有效范围内
        if (scrollLeft > maxScroll) {
            scrollLeft = maxScroll;
            scrollContainer.scrollLeft = scrollLeft;
        } else if (scrollLeft < 0) {
            scrollLeft = 0;
            scrollContainer.scrollLeft = scrollLeft;
        }

        // 不需要滚动时，隐藏按钮和进度条
        const scrollable = maxScroll > 1;
        
        // 更新居中状态
        updateCenteredState();
        
        // 更新按钮状态
        if (prevButton) {
            if (!scrollable || scrollLeft <= 1) {
                prevButton.style.visibility = 'hidden';
                prevButton.classList.remove('is-show');
            } else {
                prevButton.style.visibility = 'visible';
                prevButton.classList.add('is-show');
            }
        }
        
        if (nextButton) {
            if (!scrollable || scrollLeft >= maxScroll - 1) {
                nextButton.style.visibility = 'hidden';
                nextButton.classList.remove('is-show');
            } else {
                nextButton.style.visibility = 'visible';
                nextButton.classList.add('is-show');
            }
        }
        
        // 更新自定义滚动条（用progress容器和progress-bar作为轨道和thumb）
        if (progressContainer && progressBar) {
            const trackWidth = progressContainer.clientWidth || 0;
            const visibleWidth = getContainerVisibleWidth();
            const scrollWidth = getContentScrollWidth();
            
            // 轨道无宽度或无需滚动则隐藏
            if (trackWidth <= 0 || !scrollable) {
                progressContainer.style.display = 'none';
            } else {
                progressContainer.style.display = 'block';
                
                // 固定thumb宽度：PC 66px，移动端 32px，且不超过轨道
                const desiredThumb = window.innerWidth <= 768 ? 32 : 66;
                const thumbWidth = Math.min(trackWidth, desiredThumb);
                const maxThumbLeft = Math.max(0, trackWidth - thumbWidth);
                
                const clampedScroll = Math.max(0, Math.min(maxScroll, scrollLeft));
                const thumbLeft = maxScroll > 0 ? (clampedScroll / maxScroll) * maxThumbLeft : 0;
                
                progressBar.style.width = `${thumbWidth}px`;
                progressBar.style.transform = `translateX(${thumbLeft}px)`;
            }
        }
    }
    
    // 滑动到指定位置
    function slideTo(direction) {
        const scrollContainer = getScrollContainer();
        if (!scrollContainer) return;
        
        const maxScroll = getMaxScroll();
        const currentScroll = Math.min(scrollContainer.scrollLeft, maxScroll);
        
        // 计算item宽度和gap
        if (items.length === 0) return;
        const firstItem = items[0];
        const itemRect = firstItem.getBoundingClientRect();
        const itemWidth = itemRect.width;
        const computedStyle = window.getComputedStyle(track);
        const gap = parseFloat(computedStyle.gap) || 32;
        
        // 计算滑动距离：一次滑动slideStep个item
        const scrollDistance = slideStep * (itemWidth + gap);
        
        let targetScroll;
        if (direction === 'next') {
            targetScroll = Math.min(currentScroll + scrollDistance, maxScroll);
        } else {
            targetScroll = Math.max(currentScroll - scrollDistance, 0);
        }
        
        scrollContainer.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
        });
        
        // 滚动事件监听器会自动更新进度条，这里只需要在滚动动画完成后做一次检查
        // 使用延迟检查确保在平滑滚动完成后进度条正确显示
        setTimeout(function() {
            const currentLeft = scrollContainer.scrollLeft;
            const currentMaxScroll = getMaxScroll();
            if (currentLeft >= currentMaxScroll - 0.5) {
                updateUI(100);
            } else if (currentLeft <= 0.5) {
                updateUI(0);
            } else {
                updateUI();
            }
        }, 500); // 等待平滑滚动动画完成
    }
    
    // 设置事件监听
    function setupEventListeners() {
        // 按钮事件
        if (prevButton) {
            prevButton.addEventListener('click', () => slideTo('prev'));
        }
        
        if (nextButton) {
            nextButton.addEventListener('click', () => slideTo('next'));
        }
        
        // 滚动事件 - 使用命名函数，避免重复绑定
        const scrollContainer = getScrollContainer();
        if (scrollContainer && !scrollContainer._scrollHandler && needsScroll()) {
            scrollContainer._scrollHandler = function() {
                const currentScrollLeft = scrollContainer.scrollLeft;
                const currentMaxScroll = getMaxScroll();
                
                // 如果滚动到最右边，强制进度条为 100%
                if (currentScrollLeft >= currentMaxScroll - 0.5) {
                    updateUI(100);
                } else if (currentScrollLeft <= 0.5) {
                    updateUI(0);
                } else {
                    updateUI();
                }
            };
            scrollContainer.addEventListener('scroll', scrollContainer._scrollHandler);
        }
        
        // 窗口大小变化事件
        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                // 重新计算slideStep
                let newSlideStep = parseInt(featureProductSlider.dataset.sliderNumbers) || 1;
                if (window.innerWidth <= 480 && newSlideStep > 3) {
                    newSlideStep = 3;
                } else if (window.innerWidth <= 768 && newSlideStep > 4) {
                    newSlideStep = 4;
                } else if (window.innerWidth < 1200 && newSlideStep > 6) {
                    newSlideStep = 6;
                } else if (window.innerWidth >= 1200 && newSlideStep > 8) {
                    newSlideStep = 8;
                }
                slideStep = newSlideStep;
                
                // 重新绑定滚动事件
                const sc = getScrollContainer();
                if (sc) {
                    // 移除旧的事件监听器
                    if (sc._scrollHandler) {
                        sc.removeEventListener('scroll', sc._scrollHandler);
                        sc._scrollHandler = null;
                    }
                    
                    // 重新绑定滚动事件
                    if (needsScroll()) {
                        sc._scrollHandler = function() {
                            const currentScrollLeft = sc.scrollLeft;
                            const currentMaxScroll = getMaxScroll();
                            
                            // 如果滚动到最右边，强制进度条为 100%
                            if (currentScrollLeft >= currentMaxScroll - 0.5) {
                                updateUI(100);
                            } else if (currentScrollLeft <= 0.5) {
                                updateUI(0);
                            } else {
                                updateUI();
                            }
                        };
                        sc.addEventListener('scroll', sc._scrollHandler);
                    }
                }
                
                // 延迟更新UI，确保布局已重新计算
                setTimeout(function() {
                    const currentScrollLeft = sc ? sc.scrollLeft : 0;
                    const currentMaxScroll = getMaxScroll();
                    if (currentScrollLeft >= currentMaxScroll - 0.5) {
                        updateUI(100);
                    } else {
                        updateUI();
                    }
                    // 更新居中状态
                    updateCenteredState();
                }, 100);
            }, 200);
        });
        
        // PC端鼠标滚轮横向滚动
        if (window.innerWidth > 768) {
            const scrollContainer = getScrollContainer();
            const sliderBox = featureProductSlider.querySelector('.featured-products-slider-box');
            if (scrollContainer && sliderBox && !sliderBox._wheelHandler && needsScroll()) {
                sliderBox._wheelHandler = function(e) {
                    // 检查鼠标是否在slider-box内
                    const rect = sliderBox.getBoundingClientRect();
                    if (e.clientX >= rect.left && e.clientX <= rect.right &&
                        e.clientY >= rect.top && e.clientY <= rect.bottom) {
                        // 阻止默认垂直滚动
                        if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
                            e.preventDefault();
                            
                            const maxScroll = getMaxScroll();
                            let newScrollLeft = scrollContainer.scrollLeft + e.deltaY;
                            
                            // 限制在有效范围内
                            if (newScrollLeft > maxScroll) {
                                newScrollLeft = maxScroll;
                            } else if (newScrollLeft < 0) {
                                newScrollLeft = 0;
                            }
                            
                            scrollContainer.scrollLeft = newScrollLeft;
                            
                            // 立即更新UI（进度条和按钮状态）
                            // 如果到达最右边，强制进度条为 100%
                            if (newScrollLeft >= maxScroll - 0.5) {
                                updateUI(100);
                            } else {
                                setTimeout(updateUI, 0);
                            }
                        }
                    }
                };
                sliderBox.addEventListener('wheel', sliderBox._wheelHandler, { passive: false });
            }
        }
    }
    
    // 初始化
    function init() {
        // 等待DOM完全渲染
        requestAnimationFrame(function() {
            setTimeout(function() {
                setupEventListeners();
                
                // 初始化时检查滚动位置，确保进度条正确显示
                const scrollContainer = getScrollContainer();
                if (scrollContainer) {
                    const currentScrollLeft = scrollContainer.scrollLeft;
                    const currentMaxScroll = getMaxScroll();
                    
                    if (currentScrollLeft >= currentMaxScroll - 0.5) {
                        updateUI(100);
                    } else if (currentScrollLeft <= 0.5) {
                        updateUI(0);
                    } else {
                        updateUI();
                    }
                } else {
                    updateUI();
                }
                
                // 初始化时更新居中状态
                updateCenteredState();
            }, 100);
        });
    }
    
    init();
});
